export enum PromocodeType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
}

export enum InactiveReason {
  EXPIRED = 'EXPIRED',
  REMOVED = 'REMOVED',
  LIMIT_REACHED = 'LIMIT_REACHED',
}
